module.exports = __webpack_public_path__ + "static/img/pic42.b830ea89.png";